import React, { useState } from "react";

import logo from "../../../images/paznic-logo.png";

export function LogoImage() {
    const [loaded, setLoaded] = useState(false);

    return (
        <img
            src={logo}
            alt="Paznic logo"
            style={{
                display: loaded ? "block" : "none",
                margin: "auto",
                width: "200px",
            }}
            onLoad={() => setLoaded(true)}
            onError={() => setLoaded(false)}
        />
    );
}
